import { useCallback } from 'react';

export const useDropdownFiltersMap = ({ selectedFiltersWithSubFiltersMap, setSelectedFiltersWithSubFiltersMap }) => {
    const setSelectedFiltersWithSubFilters = useCallback(
        ({ selectedFilter, selectedSubFilters }) => {
            setSelectedFiltersWithSubFiltersMap(prevSelectedFiltersWithSubFiltersMap => {
                if (selectedSubFilters.length === 0) {
                    const { [selectedFilter.name]: _, ...updatedFilters } = prevSelectedFiltersWithSubFiltersMap;
                    return updatedFilters;
                }
                return {
                    ...prevSelectedFiltersWithSubFiltersMap,
                    [selectedFilter.name]: {
                        selectedFilter,
                        selectedSubFilters,
                    },
                };
            });
        },
        [setSelectedFiltersWithSubFiltersMap]
    );

    return { selectedFiltersWithSubFiltersMap, setSelectedFiltersWithSubFilters };
};
